import {findContainer, getDataAttributes} from "./_util";
import {Modal} from "../../index.esm";

const VGModal = {
	isAdded: false,
	isInit: false,
	cross: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 224.512 224.512" style="enable-background:new 0 0 224.512 224.512;" xml:space="preserve"><g><polygon style="fill:#010002;" points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254 "/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>',

	init: function (modal, arg = {}) {
		if (!modal) {
			VGLog("error", ["Товарищ! Первый параметр не должен быть пустым!"]);
			return false;
		}

		let params = {
			type: 'bootstrap',
			cloned_content: 'false'
		}, dataParams = {};

		if (typeof modal === 'string') {
			params.modal = findContainer(modal);
			if (params.modal) dataParams = getDataAttributes(params.modal);
		} else if (typeof modal === 'object') {
			let target = modal.dataset.target || modal.getAttribute('href') || null;

			if (!target) {
				VGLog("error", ["Мон Синьор! Путь к модалке не найден"]);
				return false;
			}
			params.modal = findContainer(target);
			dataParams = getDataAttributes(modal);
		} else {
			VGLog("error", ["КЭП! Какая-то дичь к нам залетела"]);
			return false;
		}

		if (!params.modal) {
			VGLog("error", ["Сударь! А где, собственно, модалка?"]);
			return false;
		}

		params = Object.assign({}, dataParams, params, arg);

		VGModal.isInit = true;
		VGModal.run(params);
	},

	run: function (params) {
		if (!VGModal.isInit) return false;

		let $modal = params.modal,
			$type = params.type,
			$cloned_content = params.cloned_content;

		let dParams = ['modal', 'type', 'cloned_content', 'data-vg-toggle'];
		dParams.forEach(function (value) {
			delete params[value];
		});

		for (let key in params) {
			let value = params[key];

			if (!VGModal.isAdded) {
				let $elements = $modal.querySelectorAll('[' + key + ']');
				for (let $tag of $elements) {
					if ($tag.tagName === 'INPUT' || $tag.tagName === 'TEXTAREA') {
						$tag.value = value;
					} else if ($tag.tagName === 'IMG') {
						$tag.setAttribute('src', value);
					} else if (key === 'data-action') {
						$tag.setAttribute('action', value);
					} else {
						$tag.textContent = value;
					}
				}
			}

			if (key === 'data-map') {
				VGModal.map('yaMap', value.split(','));
			}

			if(key === 'data-is-added') {
				VGModal.isAdded = true;
			}
		}

		if ($type === 'bootstrap') {
			VGModal.modalBootstrap($modal, $type, params);
		} else if ($type === 'fancybox') {
			VGModal.modalFancybox($modal, $type, params);
		}
	},

	modalBootstrap: function ($modal, $type, params) {
		if (!VGModal.isInit) return false;

		let $modalBtnClose = $modal.querySelector('.modal-close-block');
		if (!$modalBtnClose) {
			let div = document.createElement('div');
			div.className = "modal-close-block";

			let $content = $modal.querySelector('.modal-content');
			div.innerHTML = '<button type="button" class="modal-close white" data-bs-dismiss="modal" aria-label="Close">' + VGModal.cross + '</button>';
			$content.prepend(div);
		} else {
			$modalBtnClose.innerHTML = '<button type="button" class="modal-close white" data-bs-dismiss="modal" aria-label="Close">' + VGModal.cross + '</button>';
		}

		let modal = new Modal($modal, params);
		modal.show();

		if ('data-reload' in params) {
			$modal.addEventListener('hidden.bs.modal', event => {
				location.reload();
			});
		}
	},

	modalFancybox: function ($modal, $type, params) {
		if (!VGModal.isInit) return false;

		let $modalBtnClose = $modal.querySelector('.modal-close-block');
		if (!$modalBtnClose) {
			let div = document.createElement('div');
			div.className = "modal-close-block";
			div.innerHTML = '<button type="button" data-fancybox-close class="modal-fbx-close white" title="CLOSE" aria-label="Close">' + VGModal.cross + '</button>';
			$modal.prepend(div);
		} else {
			$modalBtnClose.innerHTML = '<button type="button" data-fancybox-close class="modal-fbx-close white" title="CLOSE" aria-label="Close">' + VGModal.cross + '</button>';
		}

		params.src = '#' + $modal.id;
		params.type = 'inline';
		params.closeButton = false;

		fbx.Fancybox.show([params]);
	},

	map: function (id, coordinate) {
		let $map = document.querySelector('#' + id + ' ymaps');
		$map.remove();

		let myMap;
		yaMapInit(id);

		function yaMapInit(map_ID) {
			ymaps.ready(init);

			function init() {
				let lat = coordinate[0];
				let lon = coordinate[1];

				myMap = new ymaps.Map(map_ID, {
					center: [lat, lon],
					zoom: 16
				}, {
					searchControlProvider: 'yandex#search',
					suppressMapOpenBlock: true,
				});

				myMap.controls.remove('typeSelector');
				myMap.controls.remove('fullscreenControl');
				myMap.controls.remove('trafficControl');
				myMap.controls.remove('searchControl');

				myMap.geoObjects
				.add(new ymaps.Placemark([lat, lon], {
					balloonContent: ''
				}, {
					preset: 'islands#icon',
					iconColor: '#ff3819'
				}));

				if (window.innerWidth < 1000) {
					myMap.behaviors.get('drag').disable();
				}

				myMap.behaviors.disable('scrollZoom');
			}

			return false;
		}
	}
};

function onReady() {
	let $btnModal = document.querySelectorAll('[data-vg-toggle="modal"]');
	if ($btnModal.length) {
		for (let $btn of $btnModal) {
			$btn.onclick = function () {
				VGModal.init(this);
				return false;
			};
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);

export default VGModal;